import { render, staticRenderFns } from "./DisplayTab.vue?vue&type=template&id=5798f3b0&scoped=true"
import script from "./DisplayTab.vue?vue&type=script&lang=ts"
export * from "./DisplayTab.vue?vue&type=script&lang=ts"
import style0 from "./DisplayTab.vue?vue&type=style&index=0&id=5798f3b0&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5798f3b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5798f3b0')) {
      api.createRecord('5798f3b0', component.options)
    } else {
      api.reload('5798f3b0', component.options)
    }
    module.hot.accept("./DisplayTab.vue?vue&type=template&id=5798f3b0&scoped=true", function () {
      api.rerender('5798f3b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/DisplayTab.vue"
export default component.exports